import { useContext, useState } from "react";
import { Spinner } from "@blueprintjs/core";

import Button from "../../components/atoms/Button";
import Business from "../../models/business";

import SettingsSection from "./SettingsSection";
import { SectionProps } from ".";
import BusinessContext from "../../contexts/business";
import TermsAndConditionsDialog from "./TermsAndConditionsDialog";

import "./force-list-styles.css";

export type TermsAndConditionsSectionFormProps = {
	business?: Business;
	loading?: boolean;
};

export type TermsAndConditionsSectionProps = {
	terms_and_conditions: string;
	enable_terms_and_conditions?: boolean;
}

const Loading = () => {
	return (
		<div>
			<Spinner />
		</div>
	);
};

const TermsAndConditionsSection = (props: SectionProps<TermsAndConditionsSectionProps, any> & TermsAndConditionsSectionFormProps) => {
	const [isDialogOpen, setIsDialogOpen] = useState(false);
	const { business, isLoading: isBusinessLoading } = useContext(BusinessContext);

	const isLoading = props.loading || isBusinessLoading;

	if (isLoading) {
		return (
			<SettingsSection title="Bank">
				<Loading />
			</SettingsSection>
		);
	}

	const onModifyTermsAndConditions = () => {
		setIsDialogOpen(true);
	};

	return (
		<SettingsSection title="Terms and Conditions">
			<div className="flex flex-col gap-6">
				<div
					className="terms-and-conditions"
					style={{ maxHeight: 400, overflow: "clip" }}
					dangerouslySetInnerHTML={{__html: business?.termsAndConditions || ""}}
				/>
				<Button
					disabled={isLoading}
					text="Modify Terms And Conditions"
					intent="primary"
					loading={isLoading}
					onClick={onModifyTermsAndConditions}
				/>
			</div>
			<TermsAndConditionsDialog
				isOpen={isDialogOpen}
				onClose={() => setIsDialogOpen(false)}
			/>
		</SettingsSection>
	);
};

export default TermsAndConditionsSection;
